import ProductCategory from './ProductCategory'
import { AemTopNavItem } from '@src/types/graphql-types'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme) => ({
  textLink: {
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.primary.main,
    cursor: 'pointer',
  },
  categoryItem: {
    margin: theme.spacing(3, 0),
    padding: 0,
  },
}))

interface ProductCategoryListProps {
  items: AemTopNavItem[]
}

const ProductCategoryList: React.FC<ProductCategoryListProps> = ({ items }) => {
  const { classes } = useStyles()
  return (
    <>
      {items.map((item) => {
        if (!item || !item.title || !item.url) return null
        return (
          <li key={item.title} className={classes.categoryItem}>
            <ProductCategory category={item.title} url={item.url} />
          </li>
        )
      })}
    </>
  )
}

export default ProductCategoryList
